<template>
    <b-modal :title="title" ref="confirmation-action" id="confirmation-action" centered no-close-on-backdrop @hide="hide">
        <p>
            {{ description }}
        </p>

        <template v-slot:modal-footer>
            <ci-button type="gray" :disabled="loading" @click="cancelAction" :text="$t('cancel')" />

            <ci-button type="red" :loading="loading" @click="confirmAction" :text="$t('confirm')" />
        </template>
    </b-modal>
</template>
<script>
export default {
    name: 'ActionConfirmationModal',
    props: {
        loading: Boolean,
    },
    data() {
        return {
            title: '',
            description: '',
            callback: null,
        }
    },

    methods: {
        show(title = '', description = '', callback = () => {}) {
            this.title = title
            this.description = description
            this.callback = callback

            this.$refs['confirmation-action'].show()
        },

        hide() {
            this.title = ''
            this.description = ''
            this.callback = null

            this.$refs['confirmation-action'].hide()
        },

        cancelAction() {
            this.hide()
            this.$emit('cancel')

            if (this.callback) {
                this.callback(false)
            }
        },

        confirmAction() {
            this.$emit('confirm')

            if (this.callback) {
                this.callback(true)
            }
        },
    },
}
</script>
